import React from 'react';
import CommonComponent from '../CommonComponent';
import { appMethod as app } from '@utils/app';
import { customEvent } from '@utils/customEvent';

import './Recommend.less';

var eventSource = [{ action: "get-coupon", name: "优惠券详情", local_icon: "icon-news-coupon" }, { action: "goods-trade", name: "商品详情", local_icon: "icon-news-goodsdetail" }, { action: "community", name: "社区详情", local_icon: "icon-news-community" }, { action: "to-franchisee", name: "商家详情", local_icon: "icon-news-business" }, { action: "coupon-receive-list", name: "优惠券列表", local_icon: "icon-news-coupon" }, { action: "recharge", name: "储值", local_icon: "icon-news-storage" }, { action: "transfer", name: "付款", local_icon: "icon-news-payment" }, { action: "to-promotion", name: "代言人中心", local_icon: "icon-news-extension" }, { action: "scratch-card", name: "刮刮乐", local_icon: "icon-news-scratch" }, { action: "lucky-wheel", name: "大转盘", local_icon: "icon-news-turntable" }, { action: "golden-eggs", name: "砸金蛋", local_icon: "icon-news-goldegg" }, { action: "call", name: "拨打电话", local_icon: "icon-news-callphone" }, { action: "turn-to-xcx", name: "跳转action小程序", local_icon: "icon-news-jump" }, { action: "share", name: "分享好友", local_icon: "icon-news-sharefriends" }, { action: "page-share", name: "分享朋友圈", local_icon: "icon-news-sharecircle" }, { action: "refresh-list", name: "刷新列表", local_icon: "icon-news-refreshlist" }, { action: "refresh-page", name: "刷新页面", local_icon: "icon-news-refreshpage" }, { action: "contact", name: "联系客服", local_icon: "icon-news-custom" }, { action: "preview-picture", name: "预览大图", local_icon: "icon-news-coupon" }, { action: "to-seckill", name: "秒杀", local_icon: "icon-news-kill" }, { action: "video-detail", name: "视频详情", local_icon: "icon-news-videodetail" }, { action: "topic", name: "话题详情", local_icon: "icon-news-topic" }, { action: "news", name: "资讯详情", local_icon: "icon-news-news" }, { action: "goods-scan-code", name: "扫码购", local_icon: "icon-shopping-scan" },{ action: "vcard", name: "名片详情", local_icon: "icon-vcard" }, { action: "vcard-msg-list", name: "名片消息列表", local_icon: "icon-vcard-msg-list" }];


function ArticleRecommendItem(props){
  let item = props.item;
  return (
    <div className="recommend-item">
      <div className="recommend-article" style={{width: item.style != 1 || item.form_data.url.video ? '70%' : '100%'}}>
        <div className="recommend-content">{item.title}</div>
        {
          item.article_type == 3 ? (
            <div className="recommend-adver-footer">
              <span className="recommend-adver-tag">推荐</span>
              <span className="recommend-publish-time">{item.publish_time}</span>
            </div>
          ) : (
            <div className="recommend-key-words">
              <span className="recommend-comment-text">{item.comment_count}评论</span>
              <span className="recommend-comment-text">{item.publish_time}</span>
            </div>
          )
        }
      </div>
      {
        (item.style != 1 || item.form_data.url.video || item.form_data.video[0]) && (
          <div className="img-wrap">
            <img src={item.imgs || (item['form_data'] && item['form_data']['video'] && item['form_data']['video'][0] && item['form_data']['video'][0]['video_url']) || (item['form_data'] && item['form_data']['video'] && item['form_data']['url']['video']['cover'])} />
            {
              ((item['form_data'] && item['form_data']['url'] && item['form_data']['url']['video'] && item['form_data']['url']['video']['cover']) || (item['form_data'] && item['form_data']['video'] && item['form_data']['video'][0] && item['form_data']['video'][0]['video_url'])) && (
                <div className="icon-wrap">
                  <label className="ico-moon icon-news-video-play"></label>
                </div>
              )
            }
          </div>
        )
      }
    </div>
  )
}

export class Recommend extends CommonComponent {
  constructor(props) {
    super(props);

    this.state = {
      recommendInfo: [],
      storeStyle: {},
      appLogo: app.globalData.appLogo,
      franchiseeId: ""
    }
  }

  componentDidMount(){
    this.getAppECStoreConfig();
  }

  show = (options) => {
    if(options.franchiseeId){
      this.setState({
        franchiseeId: options.franchiseeId
      })
    }
  }

  getAppECStoreConfig = () => {
    app.getAppECStoreConfig((res) => {
      res.recommend_config && res.recommend_config.map((item) => {
        item.recommend_info = item.recommend_info.map(rg => {
          if (item.recommend_type == 3) {
            if (!rg.name) {
              rg.name = rg.pageRouterName ? rg.pageRouterName.split('/').pop() : '';
            }
            rg.iconImg = rg.iconImg ? rg.iconImg : rg.icon;
            if (!rg.name || !rg.iconImg || /click_event.*svg$/.test(rg.iconImg)) {
              let eventObj = eventSource.find(eb => eb.action == rg.action);
              if (eventObj) {
                rg.name || (rg.name = eventObj.name);
                if (!rg.iconImg || /click_event.*svg$/.test(rg.iconImg)) {
                  rg.local_icon = eventObj.local_icon;
                }
              }
            }
            return rg;
          } else if (item.recommend_type == 0) {
            if (rg.article_type == 3 && rg.form_data.event.action) {
              let oldEventParams = rg.form_data.event,
                newEventParams = {};
              Object.keys(oldEventParams).forEach(k => {
                if (/\-/.test(k)) {
                  newEventParams[k.replace(/\-/g, '_')] = oldEventParams[k];
                } else {
                  newEventParams[k] = oldEventParams[k];
                }
              });
              rg.event_params = newEventParams;
            } else {
              rg.event_params = '';
            }
            if (rg.form_data && rg.form_data.recommend) {
              delete rg.form_data.recommend;
            }
            return rg;
          }
          return rg;
        });
      })
      this.setData({
        storeStyle: res.color_config,
        recommendInfo: res.recommend_config || []
      });
    }, this.data.franchiseeId);
  }
  gotoCouponDetail = (event) => {
    let id = event.currentTarget.dataset.couponId;
    let franchiseeParam = this.data.franchiseeId ? ('&franchisee=' + this.data.franchiseeId) : '';
    app.turnToPage('/pages/couponDetail/couponDetail?couponStatus=recieve&detail=' + id + franchiseeParam);
  }

  turnToArticle = (event) => {
    if (event.currentTarget.dataset.articleType == 3) {
      this.bindEventTapHandler(event);
      return;
    }
    let id = event.currentTarget.dataset.id;
    let franchiseeParam = this.data.franchiseeId ? ('&franchisee=' + this.data.franchiseeId) : '';
    app.turnToPage('/informationManagement/pages/newsDetail/newsDetail?detail=' + id + franchiseeParam);
  }

  turnToGoodsDetail = (event) => {
    let id = event.currentTarget.dataset.id,
      style = event.currentTarget.dataset.style;
    let franchiseeParam = this.data.franchiseeId ? ('&franchisee=' + this.data.franchiseeId) : '';
    if (style == 3) {
      app.turnToPage('/pages/toStoreDetail/toStoreDetail?detail=' + id + franchiseeParam);
    } else {
      app.turnToPage('/pages/goodsDetail/goodsDetail?detail=' + id + franchiseeParam);
    }
  }

  bindEventTapHandler = (e) => {
    let form = JSON.parse(e.currentTarget.dataset.eventParams);;
    customEvent({
      customFeature: form,
      franchisee: this.data.franchiseeId,
      event: e
    })
  }


  render(){
    let { 
      recommendInfo,
      appLogo,
      storeStyle
    } = this.state;

    return (
      <div className="common-component recommend-wrap">
        {
          recommendInfo && recommendInfo.map((recommendItem, index) => (
            <div className="recommend-box" key={index}>
              {
                (recommendItem.recommend_type == 3 && recommendItem.recommend_info.length != 0) && (
                  <div className="more-operations">
                    <div className="recommend-title">更多操作</div>
                    <div className={`operations-wrap operations${recommendItem.recommend_info.length < 3 ? recommendItem.recommend_info.length : '3'}`}>
                      {
                        recommendItem.recommend_info.map((recList, recIndex) => (
                          <div className="operations-inner" key={recIndex}>                        
                            <div onClick={this.bindEventTapHandler} data-event-params={JSON.stringify(recList)}>
                              <div className="icon-wrap">
                                {
                                  recList.local_icon ? <label className={`ico-moon ${recList.local_icon}`}></label> : <img className="recommend-image-icon" src={recList.iconImg} />
                                }
                              </div>
                              <div className="name">{recList.name}</div>
                            </div>
                          </div>
                        ))
                      }
                    </div>
                  </div>
                )
              }
              {
                (recommendItem.recommend_type == 0 && recommendItem.recommend_info.length > 0) && (
                  <div>
                    <div className="recommend-title">推荐文章</div>
                    {
                      recommendItem.recommend_info.map((item) => (
                        <React.Fragment key={item.id}>
                        {
                          item.is_publish == 1 && 
                            <div className="recommmend-list">
                              <div data-id={item.id} onClick={this.turnToArticle} data-article-type={item.article_type} data-event-params={JSON.stringify(item.event_params)}>
                                <ArticleRecommendItem item={item}></ArticleRecommendItem>
                              </div>
                            </div>
                        }
                        </React.Fragment>
                      ))
                    }
                  </div>
                )
              }
              {
                (recommendItem.recommend_type == 1 && recommendItem.recommend_info.length > 0) && (
                  <div className="goods-list">
                    <div className="recommend-title">推荐商品</div>
                    {
                      recommendItem.recommend_info.map((item, index) => (
                        <div className="recommmend-list recommend-item" data-id={item.id} onClick={this.turnToGoodsDetail} data-style={item.goods_type} key={index}>
                          <div className="recommend-item-inner">
                            <div className="img-wrap">
                              <img src={item.cover} />
                            </div>
                            <div className="recommend-article">
                              <div className="recommend-goods-title">{item.title}</div>
                              <div className="recommend-goods-price" style={{color: storeStyle.theme}}>¥{item.price}</div>
                              <div className="recommend-goods-sales">月销{item.sales}件</div>
                            </div>
                          </div>
                        </div>
                      ))
                    }
                  </div>
                )
              }
              {
                (recommendItem.recommend_type == 2 && recommendItem.recommend_info.length > 0) && (
                  <div className="ticket">
                    <div className="recommend-title">福利领取</div>
                    {
                      recommendItem.recommend_info.map((coupon, index) => (
                        <div className="recommmend-list" key={index} onClick={this.gotoCouponDetail} data-coupon-id={ coupon.id }>
                          <div className="top-section">
                            <img className="ticket-image" src={ appLogo } />
                            <div className="detail-info">
                              <div className="name">{ coupon.title }</div>
                              <div className="use-condition">使用条件：{ coupon.discount }</div>
                            </div>
                            <div className="receive-btn" onClick={this.gotoCouponDetail} data-coupon-id={ coupon.id } >领取</div>
                          </div>
                        </div>
                      ))
                    }
                  </div>
                )
              }
            </div>
          ))
        }
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/common/recommend/Recommend.jsx